import React from 'react';
import styled from '@emotion/styled';
import image from '../images/500.jpg';
import ErrorContent from './ErrorContent';

const Styled500Container = styled.div`
  background: #173c47 url('${image}') center center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  left: 0;
  top: 50px;
`;

export default () => {
  const primaryMessage = 'Something went wrong.';
  const secondaryMessage = 'Sorry for the trouble!';
  return (
    <Styled500Container>
      <ErrorContent primaryMessage={primaryMessage} secondaryMessage={secondaryMessage} />
    </Styled500Container>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/Error500.jsx